/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const contextRouteParams = {
  eventID: 'currentEventID',
};

const EventRouteLinkItem = (props) => (
  <RouteLinkItem contextRouteParams={contextRouteParams} {...props} />
);

export default EventRouteLinkItem;
